import React from 'react';
import { ConfigProvider } from 'antd';
import ru_Ru from 'antd/es/locale/ru_RU';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import 'antd/dist/antd.min.css';
import 'moment/locale/ru';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ConfigProvider locale={ru_Ru}>
    <App />
  </ConfigProvider>,
);
